import moment from 'moment';

enum FeatureToggles {
  landlord = 'landlord',
  configRequest = 'configRequest',
  homeRetrieve = 'homeRetrieve',
  landlordRetrieve = 'landlordRetrieve',
  campaign = 'campaign',
  skipPromoPage = 'skipPromoPage',
  skipHomePromoPage = 'skipHomePromoPage',
  skipLandlordPromoPage = 'skipLandlordPromoPage',
  paymentPortal = 'paymentPortal',
  paymentPortalErrorMessage = 'paymentPortalErrorMessage',
  ccMaintenanceOutage = 'ccMaintenanceOutage',
}

export enum FeatureToggleState {
  ON = 'ON',
  OFF = 'OFF',
}

enum BaseUrls {
  BFF_BASE_URL = 'BFF_BASE_URL',
  WESTPAC_BASE_URL = 'WESTPAC_BASE_URL',
  PEGA_CAMPAIGN_IMAGE_BASE_URL = 'PEGA_CAMPAIGN_IMAGE_BASE_URL',
}

interface Config {
  junctionPath: string;
  baseUrls: { [key in BaseUrls]: string };
  featureToggles: { [key in FeatureToggles]: string };
  thirdPartyCoverLimit: string;
  ossUrl: string;
}

const config: Config = {
  junctionPath: process.env.REACT_APP_TAM_JUNCTION_NAME ?? '',
  thirdPartyCoverLimit:
    process.env.REACT_APP_THIRD_PARTY_COVER_LIMIT ??
    '<<THIRD_PARTY_COVER_LIMIT>>',
  baseUrls: {
    [BaseUrls.WESTPAC_BASE_URL]:
      process.env.REACT_APP_WESTPAC_BASE_URL ?? '<<WESTPAC_URL>>',
    [BaseUrls.BFF_BASE_URL]:
      process.env.REACT_APP_BFF_BASE_URL ??
      `${document.location.origin}${process.env.REACT_APP_TAM_JUNCTION_NAME}/api`,
    [BaseUrls.PEGA_CAMPAIGN_IMAGE_BASE_URL]:
      process.env.REACT_APP_PEGA_CAMPAIGN_IMAGE_BASE_URL ??
      '<<PEGA_CAMPAIGN_IMAGE_BASE_URL>>',
  },
  ossUrl: process.env.REACT_APP_OSS_URL
    ? `${window.location.protocol}//${window.location.host}/${process.env.REACT_APP_OSS_URL}`
    : `${window.location.protocol}//${window.location.host}/<<OSS_URL>>`,
  featureToggles: {
    [FeatureToggles.landlord]:
      process.env.REACT_APP_FEATURE_TOGGLE_LANDLORD ??
      '<<FEATURE_TOGGLE_LANDLORD>>',
    [FeatureToggles.configRequest]:
      process.env.REACT_APP_FEATURE_TOGGLE_CONFIG_REQUEST ??
      '<<FEATURE_TOGGLE_CONFIG_REQUEST>>',
    [FeatureToggles.homeRetrieve]:
      process.env.REACT_APP_FEATURE_TOGGLE_HOME_RETRIEVE ??
      '<<FEATURE_TOGGLE_HOME_RETRIEVE>>',
    [FeatureToggles.landlordRetrieve]:
      process.env.REACT_APP_FEATURE_TOGGLE_LANDLORD_RETRIEVE ??
      '<<FEATURE_TOGGLE_LANDLORD_RETRIEVE>>',
    [FeatureToggles.campaign]:
      process.env.REACT_APP_FEATURE_TOGGLE_CAMPAIGN ??
      '<<FEATURE_TOGGLE_CAMPAIGN>>',
    [FeatureToggles.skipPromoPage]:
      process.env.REACT_APP_FEATURE_TOGGLE_SKIP_PROMO_PAGE ??
      '<<FEATURE_TOGGLE_SKIP_PROMO_PAGE>>',
    [FeatureToggles.skipHomePromoPage]:
      process.env.REACT_APP_FEATURE_TOGGLE_HOME_SKIP_PROMO ??
      '<<FEATURE_TOGGLE_HOME_SKIP_PROMO>>',
    [FeatureToggles.skipLandlordPromoPage]:
      process.env.REACT_APP_FEATURE_TOGGLE_LANDLORD_SKIP_PROMO ??
      '<<FEATURE_TOGGLE_LANDLORD_SKIP_PROMO>>',
    [FeatureToggles.paymentPortal]:
      process.env.REACT_APP_FEATURE_TOGGLE_PAYMENT_PORTAL ??
      '<<FEATURE_TOGGLE_PAYMENT_PORTAL>>',
    [FeatureToggles.paymentPortalErrorMessage]:
      process.env.REACT_APP_FEATURE_TOGGLE_PAYMENT_PORTAL_ERROR_MSG ??
      '<<FEATURE_TOGGLE_PAYMENT_PORTAL_ERROR_MSG>>',
    [FeatureToggles.ccMaintenanceOutage]:
      process.env.REACT_APP_FEATURE_TOGGLE_MAINTENANCE_PAGE_CC_OUTAGE ??
      '<<FEATURE_TOGGLE_MAINTENANCE_PAGE_CC_OUTAGE>>',
  },
};

export const activeMotorAwards = () =>
  (process.env.REACT_APP_MOTOR_AWARDS ?? '<<MOTOR_AWARDS>>').split(',');
export const activeHomeAwards = () =>
  (process.env.REACT_APP_HOME_AWARDS ?? '<<HOME_AWARDS>>').split(',');
export const policyStatusesBlockedFromPayment = () =>
  (
    process.env.REACT_APP_PAYMENT_PORTAL_MANUALLY_BLOCKED_STATUSES ??
    '<<PAYMENT_PORTAL_MANUALLY_BLOCKED_STATUSES>>'
  ).split(',');
export const isStopFunnels = () =>
  moment().isAfter(
    moment(process.env.REACT_APP_FUNNELS_STOP_DATE ?? '<<FUNNELS_STOP_DATE>>')
  );
export const switchContent = ({
  oldContent,
  newContent,
}: {
  oldContent: string;
  newContent: string;
}) =>
  moment().isAfter(
    moment(process.env.REACT_APP_REPLACE_LINK_DATE ?? '<<REPLACE_LINK_DATE>>')
  )
    ? newContent
    : oldContent;

export default config;
